import React, { Component } from 'react';
import { Card, CardTitle, CardText } from 'react-mdl';

export default  class Songwriting extends Component {

  render() {

    const titleStyle = {
      color: 'white',
      background: "url(/images/yellow_background.jpg) center / cover"
    };

    return (
  <div>
    <Card shadow={0} style={{ width: '100%', margin: 'auto' }}>
      <CardTitle style={titleStyle}>Videos</CardTitle>
      <CardText>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {/* Video 1: 2015 Retreat */}
          <li style={{ marginBottom: '20px' }}>
            <h6>SCCC 2015 Retreat</h6>
            <video width="100%" height="auto" style={{ maxWidth: '640px' }} controls controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}>  
              <source src="https://res.sccc.org.uk/media/SCCC-Retreat-2015-agm.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </li>
        </ul>
      </CardText>
    </Card>
  </div>
);
  }
}
